// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, enumOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";
import { isCallingObjectInformation } from "@dashboardApi/apis/generativeAiAgentIdLogs";

import sharedConstants from "@lib/shared_constants";

export const isGenerativeAiAgentIdLogsOutcome = enumOf(
  ...Object.values(sharedConstants.AI_SETTINGS.INVOCATION_LOG_OUTCOMES)
);

const isGenerativeAiAgentIdLogRunInvocationRow = objectOf({
  id: string,
  kind: enumOf("invocation"),
  invocation_id: string,
  position: number,
  invocation_count: number,
  duration: maybe(number, true),
  is_error: boolean,
  outcome: isGenerativeAiAgentIdLogsOutcome,
  total_tokens: maybe(number, true),
  cache_hit: boolean,
  ruleset_name: maybe(string, true),
  step_id: maybe(string, true),
  step_name: maybe(string, true),
});

const isGenerativeAiAgentIdLogRunRow = objectOf({
  id: string,
  kind: enumOf("run"),
  run_id: string,
  start_time: number,
  duration: maybe(number, true),
  invocation_count: number,
  error_count: number,
  total_tokens: number,
  calling_object_information: maybe(isCallingObjectInformation, true),
  invocations: arrayOf(isGenerativeAiAgentIdLogRunInvocationRow),
});

export const isGenerativeAiAgentIdLogRunsResult = objectOf({
  hits: number,
  hits_capped: maybe(boolean, true),
  present_outcomes: arrayOf(isGenerativeAiAgentIdLogsOutcome),
  results: arrayOf(isGenerativeAiAgentIdLogRunRow),
});
